var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0828 3.35387C32.7533 1.27343 37.2467 1.27343 40.9172 3.35387L50.225 8.62953L59.4478 14.0525C63.0847 16.191 65.3314 20.0824 65.365 24.3014L65.45 35L65.365 45.6986C65.3314 49.9176 63.0847 53.809 59.4478 55.9475L50.225 61.3705L40.9172 66.6461C37.2467 68.7266 32.7533 68.7266 29.0828 66.6461L19.775 61.3705L10.5522 55.9475C6.91528 53.809 4.66858 49.9176 4.63505 45.6986L4.55 35L4.63505 24.3014C4.66858 20.0824 6.91529 16.191 10.5522 14.0525L19.775 8.62953L29.0828 3.35387Z",
    fill: "#17233B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0799 32.58V39.42C44.0799 40.54 43.4799 41.58 42.5099 42.15L36.5699 45.58C35.5999 46.14 34.3999 46.14 33.4199 45.58L27.4799 42.15C26.5099 41.59 25.9099 40.55 25.9099 39.42V32.58C25.9099 31.46 26.5099 30.42 27.4799 29.85L33.4199 26.42C34.3899 25.86 35.5899 25.86 36.5699 26.42L42.5099 29.85C43.4799 30.42 44.0799 31.45 44.0799 32.58Z",
    stroke: "#EDFF6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 34.9998C36.2867 34.9998 37.3299 33.9566 37.3299 32.6698C37.3299 31.383 36.2867 30.3398 34.9999 30.3398C33.7131 30.3398 32.6699 31.383 32.6699 32.6698C32.6699 33.9566 33.7131 34.9998 34.9999 34.9998Z",
    stroke: "#EDFF6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40.6599C39 38.8599 37.21 37.3999 35 37.3999C32.79 37.3999 31 38.8599 31 40.6599",
    stroke: "#EDFF6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.44179002ef6d1559e072ffcd859bc5c6.svg";
export { ForwardRef as ReactComponent };